import { seoTextos, SeoTexto } from "../Assets/seoTextos";

export const buscarTextoSeo = (path: string, pais: string): SeoTexto | undefined => {
    const entrada = seoTextos[path];
    if (!entrada) {
        return undefined;
    }
    if (pais === "AR") {
        return entrada.ar;
    }
    if (pais === "UY") {
        return entrada.uy;
    }
    return undefined;
};
